import { defineMessages } from 'react-intl-next';

export const messages: {
    linkCardsMacroDescription: {
        defaultMessage: string;
        description: string;
        id: string;
    }; linkCardsMacroTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	linkCardsMacroTitle: {
		id: 'company-hub.cards-extension.manifest.macro-title',
		defaultMessage: 'Cards',
		description: 'Title of link cards macro to be displayed in toolbar/shortcut macros dropdown.',
	},
	linkCardsMacroDescription: {
		id: 'company-hub.cards-extension.manifest.macro-description',
		defaultMessage: 'Display links as cards',
		description:
			'Description of link cards macro to be displayed in toolbar/shortcut macros dropdown',
	},
});
